// extracted by mini-css-extract-plugin
export default {"input":"P--z","button":"Q--z","selected":"R--z","unavailable":"S--z","oos":"T--z","image":"U--z","paperCutDisabledOverlay":"V--z"};